import type { UpdateSettingInput } from '@features/modal-invitation/api/updateSetting';
import { mergeStylesForMail } from '@features/modal-invitation/lib/mergeStylesForMail';
import { getTextFromHtml } from '@features/modal-invitation/lib/getTextFromHtml';
import { SendChannel, SendContentType, type SendMessagesInput } from '@pages/event/api/useSendMessages';
import {
  INVITATION_TYPE_EMAIL,
  INVITATION_TYPE_SMS,
  INVITATION_TYPE_VK_TEAMS,
} from '@pages/event-send-invitations/lib/invitation-types';
import type { SelectValue } from '@shared/ui/select';

const mapSelectedChannelsToSendChannels = (channels: SelectValue[]): SendChannel[] => {
  const sendChannels: SendChannel[] = [];

  if (channels.includes(INVITATION_TYPE_VK_TEAMS)) {
    sendChannels.push(SendChannel.VK);
  }
  if (channels.includes(INVITATION_TYPE_EMAIL)) {
    sendChannels.push(SendChannel.Email);
  }
  if (channels.includes(INVITATION_TYPE_SMS)) {
    sendChannels.push(SendChannel.SMS);
  }

  return sendChannels;
};

type TicketSendPayloadInput = {
  ticketIds: number[];
  selectedChannels: SelectValue[];
  ticketText: string;
  ticketSubject: string;
  outlookSettings?: UpdateSettingInput;
  sendOutlookMeeting?: boolean;
};

export const ticketSendPayload = ({
  ticketIds,
  selectedChannels,
  ticketText,
  ticketSubject,
  outlookSettings,
  sendOutlookMeeting = false,
}: TicketSendPayloadInput): SendMessagesInput => {
  const channel = mapSelectedChannelsToSendChannels(selectedChannels);
  const ticketTextPlain = getTextFromHtml(ticketText).trim();
  const hasEmail = channel.includes(SendChannel.Email);
  const hasSmsOrVk = channel.includes(SendChannel.SMS) || channel.includes(SendChannel.VK);

  return {
    ticketIds,
    messageTemplate: hasSmsOrVk ? ticketTextPlain : '',
    emailMessageTemplate: hasEmail ? mergeStylesForMail(ticketText) : '',
    contentType: SendContentType.Ticket,
    channel,
    ...(sendOutlookMeeting ? { sendTicketCalendarMeeting: true } : {}),
    // Без канала E-mail тему не передаём: отсутствие параметра сохраняет заданную ранее.
    ...(hasEmail || outlookSettings
      ? { eventSettings: { ...outlookSettings, ...(hasEmail ? { ticketEmailSubject: ticketSubject.trim() } : {}) } }
      : {}),
  };
};
